import { PropertyData } from '@aloft/toolkit-shared';

import { applyDefaultFeatureAreas } from '../../../components/RecommendedCompSelection/utils/applyDefaultFeatureAreas.ts';
import { createAppAsyncThunk } from '../../createAppAsyncThunk.ts';
import { CompPropertyDataState, PropertyDataState, SubjectPropertyDataState } from '../../types.ts';
import { setPropertyData } from '../propertyDataSlice.ts';
import { selectDefaultFeatureAreas } from '../selectors/orderSelectors.ts';
import { selectAllPropertyData } from '../selectors/propertyDataSelectors/propertyDataSelectors.ts';

const getPropertyData = (entity: PropertyDataState): PropertyData =>
  entity.id === 'subject'
    ? ((entity as SubjectPropertyDataState).subjectData as unknown as PropertyData)
    : (entity as CompPropertyDataState).compData;

const withPropertyData = (
  entity: PropertyDataState,
  propertyData: PropertyData,
): PropertyDataState => {
  if (entity.id === 'subject') {
    return {
      ...(entity as SubjectPropertyDataState),
      subjectData: propertyData as SubjectPropertyDataState['subjectData'],
    };
  }
  return {
    ...(entity as CompPropertyDataState),
    compData: propertyData,
  };
};

export const backfillDefaultFeatureAreas = createAppAsyncThunk(
  'propertyData/backfillDefaultFeatureAreas',
  (_, { getState, dispatch }) => {
    const state = getState();
    const defaultAreas = selectDefaultFeatureAreas(state);
    const entities = selectAllPropertyData(state);

    entities.forEach((entity) => {
      const current = getPropertyData(entity);
      const next = applyDefaultFeatureAreas(current, defaultAreas, { onlyMissing: true });
      if (next !== current) {
        dispatch(setPropertyData(withPropertyData(entity, next)));
      }
    });
  },
);
